export default __webpack_public_path__ + "static/media/DSC_7503.c91e99ee.jpg";